import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Header from './pages/Header';
import Home from './pages/Home';
import Footer from './pages/Footer'; 
import Services from "./pages/Services";
import About from "./pages/About";
import Contact from "./pages/Contact"


function App() {
  return (
    <Router>
      <Header />

   
      <Routes>
         
        <Route path="/" element={<Home />} /> 
        <Route path="/services/" element={<Services />} /> 
        <Route path="/about-us/" element={<About />} />
        <Route path="/contact/" element={<Contact />} />

      </Routes>

    

      <Footer />
    </Router>
  );
}

export default App;
